import { IeLynxObject } from "../../common/models/eLynxObject";
import { RouteFromObjectType } from "../../common/utilities/RouteFromObjectType";
import restService from "../rest-service/RestService";
import { IObjectDefaultsModel, ISaveObjectDefaultsModel } from "./Models";

const DefaultsDataService = {
    getDefaults: async function (
        groupID: number,
        eLynxObject: IeLynxObject,
        signal?: AbortSignal
    ): Promise<IObjectDefaultsModel> {
        const path = `/groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/tats/defaults`

        const response = await restService.get<IObjectDefaultsModel>(path, signal);

        return response.data;
    },
    saveDefaults: async function (
        groupID: number,
        eLynxObject: IeLynxObject,
        data: ISaveObjectDefaultsModel
    ): Promise<void> {
        const path = `/groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/tats/defaults`

        await restService.post<ISaveObjectDefaultsModel, void>(path, data);

    }
}

export default DefaultsDataService;